import React, { useState, useEffect } from 'react';
import { useGlobalContext } from '../GlobalContext';

const DaftarJurnal = () => {
  const { api } = useGlobalContext();

  const [tglTransaksi, setTglTransaksi] = useState('');
  const [data, setData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [detailJurnal, setDetailJurnal] = useState(null);
  const [detailRows, setDetailRows] = useState([]);
  const [loadingDetail, setLoadingDetail] = useState(false);

  useEffect(() => {
    const today = new Date().toISOString().slice(0, 10);
    setTglTransaksi(today);
  }, []);

  const fetchData = async () => {
    try {
      const response = await api.get(`/api/akuntansi/daftarjurnal/${tglTransaksi}`);
      setData(response.data);
    } catch (err) {
      alert('Gagal mengambil data daftar jurnal');
      console.error(err);
    }
  };

  const getDetailJurnal = async (item) => {
    try {
      setLoadingDetail(true);
      const res = await api.get(`/api/akuntansi/jurnaldetail`, {params: { id: item.jnobukti }});

      const parsedData = res.data.map(row => ({
        ...row,
        debet: parseFloat(row.debet) || 0,
        kredit: parseFloat(row.kredit) || 0
      }));

      setDetailRows(parsedData);
      setDetailJurnal({ jnobukti: item.jnobukti, uraian1: item.uraian1 });
      setModalOpen(true);
    } catch (err) {
      console.error(err);
      alert('Gagal ambil detail jurnal');
    } finally {
      setLoadingDetail(false);
    }
  };

  const handleDelete = async (jnobukti) => {
    if (!window.confirm('Apakah Anda yakin ingin menghapus jurnal ini?')) return;
    try {
      await api.delete(`/api/akuntansi/jurnaldetail`, {params: { jnobukti } });
      alert('Jurnal berhasil dihapus');
      setModalOpen(false);
      fetchData();
    } catch (err) {
      console.error(err);
      alert('Gagal menghapus jurnal');
    }
  };

  const totalDebet = detailRows.reduce((a, b) => a + (b.debet || 0), 0);
  const totalKredit = detailRows.reduce((a, b) => a + (b.kredit || 0), 0);

  return (
    <div className="container mt-4">
      <div className="card">
        <div className="card-header bg-info text-white">
          <h5 className="mb-0">Daftar Jurnal</h5>
        </div>

        <div className="card-body">

          {/* FILTER */}
          <div className="card mb-3">
            <div className="card-body">
              <div className="form-inline">
                <label className="mr-2 font-weight-bold">Tanggal Jurnal</label>
                <input type="date" className="form-control mr-2" value={tglTransaksi} onChange={(e) => setTglTransaksi(e.target.value)} />
                <button onClick={fetchData} className="btn btn-primary">Display</button>
              </div>
            </div>
          </div>

          {/* TABEL */}
          <div className="card">
            <div className="card-body">
              <table className="table table-bordered table-sm">
                <thead className="thead-light">
                  <tr>
                    <th className="text-center">No</th>
                    <th>No. Jurnal</th>
                    <th>Keterangan</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? (
                    data.map((item, index) => (
                      <tr key={index}>
                        <td className="text-center">{index + 1}</td>
                        <td><button className="btn btn-link p-0 text-primary" onClick={() => getDetailJurnal(item)}>{item.jnobukti}</button></td>
                        <td>{item.uraian1}</td>
                      </tr>
                    ))
                  ) : (
                    <tr><td colSpan="3" className="text-center text-muted">Tidak ada data</td></tr>
                  )}
                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>

      {/* MODAL */}
      {modalOpen && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <div className="modal-content shadow">

              <div className="modal-header">
                <h5 className="modal-title">DETAIL JURNAL</h5>
                <button className="btn-close" onClick={() => setModalOpen(false)} />
              </div>

              <div className="modal-body">
                {loadingDetail ? (
                  <div className="text-center">Loading...</div>
                ) : (
                  <>
                    {/* INFO */}
                    <div className="mb-3">
                      <div className="row align-items-center mb-2">
                        <div className="col-md-2"><label className="fw-bold mb-0">Jnobukti</label></div>
                        <div className="col-md-9"><input className="form-control" value={detailJurnal?.jnobukti || ''} readOnly /></div>
                      </div>

                      <div className="row align-items-start">
                        <div className="col-md-2"><label className="fw-bold mb-0">Keterangan</label></div>
                        <div className="col-md-9"><input className="form-control" value={detailJurnal?.uraian1 || ''} readOnly /></div>
                      </div>
                    </div>

                    {/* TABEL DETAIL */}
                    <table className="table table-bordered table-sm">
                      <thead className="thead-light">
                        <tr>
                          <th>Kdperk</th>
                          <th>Perkiraan</th>
                          <th className="text-end" style={{ width: '150px', textAlign: 'right' }}>Debet</th>
                          <th className="text-end" style={{ width: '150px', textAlign: 'right' }}>Kredit</th>
                        </tr>
                      </thead>

                      <tbody>
                        {detailRows.length > 0 ? (
                          detailRows.map((row, i) => (
                            <tr key={i}>
                              <td>{row.kdperk}</td>
                              <td>{row.uraianperk}</td>
                              <td className="text-end" style={{ textAlign: 'right' }}> {row.debet?.toLocaleString('id-ID', { minimumFractionDigits: 2 })}</td>
                              <td className="text-end" style={{ textAlign: 'right' }}>{row.kredit?.toLocaleString('id-ID', { minimumFractionDigits: 2 })}</td>
                            </tr>
                          ))
                        ) : (
                          <tr><td colSpan="4" className="text-center text-muted">Tidak ada detail</td></tr>
                        )}
                      </tbody>

                      <tfoot className="table-secondary fw-bold">
                        <tr>
                          <td colSpan="2" className="text-end">Total</td>
                          <td className="text-end" style={{ textAlign: 'right' }}>{totalDebet.toLocaleString('id-ID', { minimumFractionDigits: 2 })}</td>
                          <td className="text-end" style={{ textAlign: 'right' }}>{totalKredit.toLocaleString('id-ID', { minimumFractionDigits: 2 })}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </>
                )}
              </div>

              <div className="modal-footer">
                <button className="btn btn-danger" onClick={() => handleDelete(detailJurnal?.jnobukti)}>Delete</button>
              </div>

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DaftarJurnal;